export const validationMessages = {
    password: [
      { type: 'required', message: 'password-required' },
      { type: 'maxlength', message: 'password-max-length' },
      {
        type: 'minlength',
        message: 'password-min-length',
      },
      {
        type: 'repeatCharacterRegexRule',
        message: 'repeat-character-regex-rule',
      },
      {
        type: 'alphabeticalCharacterRule',
        message: 'alphabetical-character-rule',
      },
      {
        type: 'digitCharacterRule',
        message: 'digit-character-rule',
      },
      {
        type: 'lowercaseCharacterRule',
        message: 'lowercase-character-rule',
      },
      {
        type: 'uppercaseCharacterRule',
        message: 'uppercase-character-rule',
      },
      {
        type: 'specialCharacterRule',
        message: 'special-character-rule',
      },
      {
        type: 'noWhitespaceRequired',
        message: 'password-no-whitespace',
      },
    ],
    userName: [
      { type: 'required', message: 'user-required' },
      { type: 'maxlength', message: 'user-max-length' },
      {
        type: 'noWhitespaceRequired',
        message: 'user-no-whitespace',
      },
      {
        type: 'minlength',
        message: 'user-min-length',
      },
    ],
    firstName: [
      { type: 'required', message: 'firstname-required' },
      { type: 'maxlength', message: 'name-max-length' },
      {
        type: 'noWhitespaceRequired',
        message: 'user-no-whitespace',
      },
      {
        type: 'minlength',
        message: 'name-min-length',
      },
    ],
    lastName: [
      { type: 'required', message: 'lastname-required' },
      { type: 'maxlength', message: 'name-max-length' },
      {
        type: 'noWhitespaceRequired',
        message: 'user-no-whitespace',
      },
      {
        type: 'minlength',
        message: 'name-min-length',
      },
    ],
    email: [
      { type: 'required', message: 'email-required' },
      { type: 'maxlength', message: 'user-max-length' },
      {
        type: 'noWhitespaceRequired',
        message: 'user-no-whitespace',
      },
      {
        type: 'minlength',
        message: 'user-min-length',
      },
    ],
    phone: [
      { type: 'required', message: 'phone-required' },
      { type: 'maxlength', message: 'phone-max-length' },
      {
        type: 'noWhitespaceRequired',
        message: 'user-no-whitespace',
      },
      {
        type: 'minlength',
        message: 'phone-min-length',
      },
    ],
  };